import React from "react";
import Header from "./Header/Header";
import {DownloadBookModal} from "./Modals";

const NewLayout = ({ children }) => {
  return (
    <div>
      <Header />
      {children}
    </div>
  );
};

export default NewLayout;
